import React from 'react';
import Stepper from '.';
import { steps } from '../utils';
import { pageStateMapping } from "..";
import { useGetCollectPaymentContext } from "../context";
import { reviewReceipt, validateSequencing } from "../utils";


const StepperWrapper = () => {

    const {
        setCurrentPageState,
        setCurrentStep,
        currentStep,
        selectedChargesAmount,
        studentBasicDetails,
        selectedCharges,
        partialAddAmount, 
        amountToBePaid,
        totalCollectedAmount,
        collectPayment,
        collectVoucherList,
        setCollectVoucherList,
        setBalanceAmount
      } = useGetCollectPaymentContext();
    
      const amountToBePaidCollected = amountToBePaid == totalCollectedAmount;
    
      const isValidStep = (stepIndex) => {
        // Add your validation logic here
        if ((stepIndex === 1 || stepIndex === 2) && selectedChargesAmount === 0) return false;
        if ((stepIndex === 2) && !amountToBePaidCollected) return false;
        return true; // Example: step 3 is invalid
      };
    
      const onClickStep = (stepIndex) => {
        setCurrentPageState(Object.keys(pageStateMapping)[stepIndex]);
      };
    
      const handleStepClick = (index) => {
        if (isValidStep(index)) {
          (index==1||index==2)&& validateSequencing(studentBasicDetails,selectedCharges,(partialAddAmount||selectedChargesAmount))
          if(index==2){
            checkReview(index)
          }
          else{
            if(index==0){
              let paidAmount=0;
              for(let i in collectVoucherList){
               paidAmount=paidAmount+ collectVoucherList[i].paidAmount
              }
              setBalanceAmount((prev)=>(prev+paidAmount))
              setCollectVoucherList([])
            }
          setCurrentStep(index);
          onClickStep(index);
          }
        }
      };
      const checkReview=async(index)=>{
        const isReview= await reviewReceipt(studentBasicDetails,amountToBePaid, selectedCharges,collectPayment,collectVoucherList)
        if(isReview){
          setCurrentStep(index);
          onClickStep(index);
        }
        else
         return;
    }

    return ( 
        <Stepper numberOfSteps={steps.length} steps={steps} currentStep={currentStep} handleStepClick={handleStepClick}/>
     );
}
 
export default StepperWrapper;